import { motion } from 'framer-motion';
import SEOHead from '../components/SEOHead';

const steps = [
  {
    number: '01',
    title: 'Set up project control',
    body: 'Create the project workspace, connect the team, and organize the core records: project details, drawings, contracts, document registers, and access permissions.',
  },
  {
    number: '02',
    title: 'Generate and review planning artifacts',
    body: 'Use AI-assisted prompts and templates to create project estimates, BOQs, house plans, drawing versions, and approval-ready revisions.',
  },
  {
    number: '03',
    title: 'Operate the build day by day',
    body: 'Run daily reports, labor attendance, material usage, purchase orders, vendor invoices, punch lists, handover packs, notifications, and cross-project reporting from the same workspace.',
  },
];

const HowItWorks = () => (
  <>
    <SEOHead
      title="How it works"
      description="See how BuildOrq helps construction teams set up projects, generate estimates and house plans, and manage daily site, materials, finance, inspections, and reporting workflows."
      url="https://buildorq.com/how-it-works"
    />

    <div className="border-b border-slate-200 bg-white">
      <div className="container-custom py-16 lg:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">How it works</p>
          <h1 className="section-title mt-2">One workspace from planning to handover.</h1>
          <p className="mt-4 text-lg text-surface-body">
            BuildOrq connects planning, field operations, commercial controls,
            quality workflows, and portfolio reporting so construction teams can
            keep the build moving without losing context.
          </p>
        </div>
      </div>
    </div>

    <div className="bg-surface-page py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-3xl space-y-10">
          {steps.map(({ number, title, body }, i) => (
            <motion.div
              key={number}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="flex gap-6 rounded-2xl border border-slate-200 bg-white p-8 shadow-card"
            >
              <span className="shrink-0 text-4xl font-bold text-primary-200">{number}</span>
              <div>
                <h2 className="text-xl font-semibold text-surface-ink">{title}</h2>
                <p className="mt-3 leading-relaxed text-surface-body">{body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </>
);

export default HowItWorks;
